import { useCallback, useEffect, useState } from "react";
export function useLocalStorage(key, initialValue, isCachedData) {
  var _a = useState(function () {
      var _a;
      return (_a = readValueFromLocalStorage(key, isCachedData)) !== null && _a !== void 0 ? _a : initialValue;
    }),
    storedValue = _a[0],
    setStoredValue = _a[1];
  useEffect(function () {
    var _a;
    setStoredValue((_a = readValueFromLocalStorage(key, isCachedData)) !== null && _a !== void 0 ? _a : initialValue);
  }, [key, isCachedData, initialValue]);
  var setValue = useCallback(function (newValue) {
    setStoredValue(function (prev) {
      if (newValue instanceof Function) {
        newValue = newValue(prev);
      }
      if (key) {
        window.localStorage.setItem(key, JSON.stringify(newValue));
      }
      return newValue;
    });
  }, [key]);
  return [storedValue, setValue];
}
function readValueFromLocalStorage(key, isCachedData) {
  if (!key) {
    return;
  }
  var cached = window.localStorage.getItem(key);
  if (!cached) {
    return;
  }
  try {
    var parsed = JSON.parse(cached);
    if (isCachedData(parsed)) {
      return parsed;
    }
  } catch (e) {}
}